import _ from "lodash";
export default {
	namespaced: true,

	state: {
		scopes: [],
		scopesDirty: false
	},

	getters: {
		scopes: state => state.scopes,

		scopesDirty: state => state.scopesDirty,

		hasNewScopes: state => _.filter(state.scopes, { future: true }).length,

		enabledOptionalScopes: state => {
			return _.filter(state.scopes, {
				optional: true,
				enabled: true
			});
		}
	},

	mutations: {
		setDirty: (state, value) => (state.scopesDirty = value),

		setScopes: (state, scopes) => {
			state.scopesDirty = false;
			state.scopes = scopes;
		},

		toggleOptionalScope: (state, id) => {
			state.scopesDirty = true;
			let found = state.scopes.find(scope => scope.id === id);
			if (found) {
				// Set the parent to the right value
				found.enabled = !found.enabled;

				// Set all the children of the parent
				_.each(_.filter(state.scopes, scope => scope.parent_id === found.id), scope => {
					scope.enabled = found.enabled;
				});
			}
		}
	},

	actions: {}
};



// WEBPACK FOOTER //
// ./src/components/private/store/scope/ScopeStore.js